import { render, staticRenderFns } from "./UnderlinedText.vue?vue&type=template&id=fe3c4b30&scoped=true"
import script from "./UnderlinedText.vue?vue&type=script&lang=js"
export * from "./UnderlinedText.vue?vue&type=script&lang=js"
import style0 from "./UnderlinedText.vue?vue&type=style&index=0&id=fe3c4b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3c4b30",
  null
  
)

export default component.exports